import React from 'react';
import { X } from 'lucide-react';

interface BookingFormProps {
  onSuccess: () => void;
}

export function BookingForm({ onSuccess }: BookingFormProps) {
  return (
    <>
      {/* Overlay */}
      <div 
        className="fixed inset-0 bg-black/50 transition-opacity z-40"
        onClick={onSuccess}
      />
      
      {/* Drawer */}
      <div className="fixed inset-y-0 right-0 w-full sm:w-[600px] lg:w-[800px] bg-white dark:bg-gray-800 shadow-xl z-50 transform transition-transform duration-300 ease-in-out">
        <div className="h-full flex flex-col">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b dark:border-gray-700">
            <h2 className="text-xl font-semibold">Réservation</h2>
            <button
              onClick={onSuccess}
              className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
              aria-label="Fermer"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
          
          {/* Content */}
          <div className="flex-1 overflow-hidden">
            <iframe 
              src="https://jadoby-hotel.amenitiz.io/fr/booking/room"
              className="w-full h-full"
              title="Système de réservation"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </>
  );
}